<template>
  <div fluid class="pa-0 ma-0">
    <div class="flex justify-center h-screen">
      <!-- Left panel will go here -->
      <!-- Added vuetify classes, helper classes check documentation https://vuetifyjs.com/en/styles/display/#display -->
      <div class="hidden sm:flex md:!w-1/3 sm:!w-1/2">
        <CarouselVue :images="$store.getters.uniLeft" />
      </div>
      <div class="d-xs-block flex justify-center md:!w-1/3 sm:!w-1/2 w-100 bg-black">
        <!-- <v-row>
          <v-col>
            <MiniPlayer />
            <MusicPlayer />
          </v-col>
        </v-row> -->
        <v-card no-gutters class="!flex !flex-col !items-center bg-black  !shadow-none border-0 w-full" 
          elevation="0" flat rounded="0">
          <v-avatar tile height="100" width="150" class="justify-self-center my-5 mb-10">
            <img class="" :src="require('@/assets/img/Logo/logo.gif')" />
          </v-avatar>
          <v-form class="sm:p-10 p-5 self-center  w-full">
            <div class="">
              <h1 class="mb-6 text-3xl font-bold uppercase font-Handel for-bg">
                Log in
              </h1>
              <p class="text-slate-300 font-Handel">
                Kindly enter your user name and password
              </p>
              <v-text-field v-model="email" :rules="[(v) => !!v || 'Email is required']" outlined
                class="border-0 !rounded-none text-red !text-sm font-Handel" color="#b99143" dark
                placeholder="Enter Your Email Address" required></v-text-field>
              <v-text-field :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" @click:append="showPassword = !showPassword" :type="showPassword ? 'text' : 'password'" v-model="password" :rules="[(v) => !!v || 'Password is required']" outlined
                class="border-0 !rounded-none text-red !text-sm font-Handel" color="#b99143" dark
                placeholder="Enter Your Password" required></v-text-field>
              <!-- <v-checkbox v-model="ex4" class="text-white font-Handel" dark label="I Accept The Terms And Conditions"
                color="#e8c278"></v-checkbox> -->
            </div>
            <v-row class="" no-gutters>
              <v-col>
                <v-btn
                  class="font-Handel font-xl rounded-0 white--text mr-2 bg-gradient-to-tl from-[#553900] via-[#ebae33] to-[#553900] hover:opacity-90"
                  text width="170" large :loading="loginUserLoading" :disabled=" !email || !password" @click.prevent="loginUser">
                  Log In
                </v-btn>
              </v-col>
              <v-col>
                <router-link class="!text-slate-300 font-Handel" to="/Forgot-password">Forget Password</router-link>
                <div class="text-xs ">
                  <span class="font-light text-slate-300 font-Handel">
                    No Account Yet ?
                  </span>
                  <router-link to="/register" class="!text-slate-100 font-medium font-Handel">Sign Up</router-link>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </div>
      <!-- Right panel will go here -->
      <div class="hidden w-1/3 md:flex">
        <CarouselVue :images="$store.getters.uniRight" />
      </div>
    </div>
  </div>
</template>

<script>
import CarouselVue from "../../../components/auth/Carousel.vue";
import MusicPlayer from "../../../components/musicplayer/player.vue";
import MiniPlayer from "../../../components/musicplayer/MiniPlayer.vue";

export default {
  components: { CarouselVue, MusicPlayer, MiniPlayer, MiniPlayer },
  
  data() {
    return {
      ex4: false,
      email: "",
      password: "",
      snackbar: false,
      text: "",
      loginUserLoading: false,
      // show n hide password
      showPassword: false,
    };
  },
  methods: {
    async loginUser() {
      try {
        this.loginUserLoading = true;
        await this.$store.dispatch("LogIn", {
          email: this.email,
          password: this.password,
        });
      } catch (error) {
        console.log("Error message", error);
      }finally{
        this.loginUserLoading = false;
      }
    },
  },
  
};
</script>

<style scoped>
.for-bg {
  background: linear-gradient(350deg,
      rgba(157, 115, 31, 1) 49%,
      rgba(219, 182, 112, 1) 56%,
      rgba(157, 115, 31, 1) 64%,
      rgba(219, 182, 112, 1) 75%,
      rgba(157, 115, 31, 1) 80%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.v-text-field--outlined:deep(fieldset) {
  border-color: #7f6415;
}

.v-text-field--outlined:deep(input) {
  color: #7f6415 !important;
}

.v-text-field--outlined:deep(input::placeholder) {
  color: #7f6415 !important;
}
.v-text-field--outlined:deep(.v-icon) {
  color: #7f6415 !important;
}
.v-input--checkbox:deep(.v-input--selection-controls__input) {
  color: #7f6415 !important;
}

.v-input--checkbox:deep(label) {
  color: #cbd5e1 !important;
  font-size: 14px;
}

.v-input--checkbox:deep(i) {
  color: #9d731f !important;
}
.text-red:deep(input:-webkit-autofill),
.text-red:deep(input:-webkit-autofill:hover),
.text-red:deep(input:-webkit-autofill:focus){
  -webkit-text-fill-color: #7f6415 !important;
  -webkit-box-shadow: 0 0 0px 40rem rgb(0, 0, 0) inset !important;
}
</style>
